'use client'

import {IntentLink as Link} from '@/components/IntentLink'
import {usePathname} from 'next/navigation'
import {useShellText} from '@/components/shell/ShellText'
import {Settings} from 'lucide-react'
import {PRIMARY_NAV} from './nav'

/** Desktop navigation. Mirrors `BottomNav`, plus settings. */
export function SideNav({locale}: {locale: string}) {
  const t = useShellText('shell')
  const pathname = usePathname()

  const items = [...PRIMARY_NAV, {href: '/settings', key: 'settings', Icon: Settings} as const]

  return (
    <nav className="u-app__side" aria-label={t('primaryNav')}>
      <ul style={{listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 4}}>
        {items.map(({href, key, Icon}) => {
          const target = `/${locale}${href}`
          const active = pathname === target || pathname.startsWith(`${target}/`)
          return (
            <li key={key}>
              <Link
                href={target}
                className="u-app__navlink"
                aria-current={active ? 'page' : undefined}
              >
                <Icon aria-hidden="true" size={18} />
                <span>{t(key)}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
